const VerifiedUsers = Object.freeze({
  VERIFIED: 'Verified',
  UNVERIFIED: 'Unverified',
  UNKNOWN: 'Unknown'
})
export default VerifiedUsers
export type VerifiedUsersStrings = typeof VerifiedUsers[keyof typeof VerifiedUsers]
// RESERVE BELOW
